export default __webpack_public_path__ + "static/media/StatesImg.2e26716c.png";